/**
 *	(c) 2024 Приволжский Исследовательский Медицинский Университет
 *
 *	@file: BottomCategoriesDisplay.jsx
 *  @description: Этот файл является частью клиентской стороны проекта. src Относится к части, которая содержит компоненты - части страниц, допускающие многократное использование в разных частях. BottomCategoriesDisplay.jsx
 *	@author: Манжос Геннадий Юрьевич, Белов Михаил Александрович
*/
import { useContext } from "react";
import { Context } from "../index";
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import { FetchTable, MakeTree } from "../utils/PageDataPrepare";

import "./Sub_Categories_Page.css"
import { PIMU_CATEGORIES_ROUTE } from "../utils/consts";

const HasDemoBadge = ({ t }) => {
    return <>
        <span className='badge rounded-pill text-bg-primary fw-normal'>
            {t('Demo_short')}
        </span>
    </>
};

const BottomCategoryButton = ({ category }) => {
    const { user } = useContext(Context);
    const history = useNavigate();
    const { pathname } = useLocation();
    const { t } = useTranslation();
    const [pimuCategory, categoryName] = pathname.substring(1).split('/');

    if (!category)
        return;

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    };

    const TryNavigateToCategory = () => {
        scrollToTop();
        user.gender = null;

        //  Добавлено 29.06.25.
        //  Для возможности отображения "внешней" уже существующей категории, необходимо, чтобы у неё было указано 'external_id' и 'external_path'.
        //  В случае, когда указано и то и другое - в зависимости от 'sublevels_count' перейти на страницу ДРУГОЙ категории.
        if (category?.external_id && category?.external_path)
        {
            if (category?.sublevels_count === 0)
                history(FetchTable[category.external_path].route + '/' + category.external_id + '?page=1&gender=3');
            else
                history(PIMU_CATEGORIES_ROUTE + FetchTable[category.external_path].route + '?page=1&gender=3');

            return;
        }

        //  Если у этой категории нет подкатегорий (sublevels_count == 0), то перейти на страницу выбора кейса.
        //  Если же у категории есть подкатегории, то перейти на страницу, где будут отображены стандартные подкатегории для выбранной.
        if (category.sublevels_count === 0)
            history(`${FetchTable[categoryName].route}/${category.id}?page=1&gender=3`);
        else
            history(`${category.id}?page=1&gender=3`);

        return;
    }

    return <button className='sub_category_card-items' onClick={TryNavigateToCategory}>
        <div className='sub_category_card-icon'>
            <img src={category.icons} alt={`Иконка категории ${category['name_' + user.language]}`} />
            {user?.access_level?.demo_access && Number(category.totalDemoCases) > 0 && (
                <div className="demo-badge-container">
                    <HasDemoBadge t={t} />
                </div>
            )}
        </div>
        <div className='sub_category_card-name'>
            {category['name_' + user.language]}
            
        </div>
    </button>;
};

const BottomCategoriesDisplay = ({ categories, matchingCategories }) => {

    if (!categories)
        return;

    let categoriesArray = categories instanceof Array ? categories : Object.keys(categories).map((key) => categories[key]);

    //  Привести объекты массива категорий к одному типу.
    categoriesArray = categoriesArray.filter((category) => typeof category == "object").map((category) => { return { ...category, sublevel: category?.sublevel === undefined ? 0 : category.sublevel }; }).sort((a, b) => a.position > b.position);

    //  Преобразовать обычный список записей в структурированный древообразный вид.
    //  Будут выделены "корневые" категории и для каждой из них будет сформирован список потомков и так до конца.
    const categoriesTree = MakeTree(categoriesArray, matchingCategories);


    return <div className='sub_category_card-list'>
        {categoriesTree.map((category) => <BottomCategoryButton key={category.id} category={category} />)}
    </div>
};

export default BottomCategoriesDisplay;